import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import React, { Dispatch, FC, SetStateAction, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import ProjectService from "@app/projects/projectService";
import { QESButton } from "@app/shared/qes-standards/Button";

interface EditRunConfigurationProps {
  updateRunConfigurationComment: (comment: string, runConfigurationId: number) => void;
  projectId: number;
  selectedRunConfigurationId: number;
  comment: string;
  setComment: Dispatch<SetStateAction<string>>
}

const EditRunConfiguration: FC<EditRunConfigurationProps> = ({
                                                               updateRunConfigurationComment,
                                                               projectId,
                                                               selectedRunConfigurationId,
                                                               comment,
                                                               setComment
                                                             }) => {
  const flyoutContext = useContext(FlyoutContext);
  const [submitting, setSubmitting] = React.useState<boolean>(false);
  const [originalComment, setOriginalComment] = React.useState<string>("");
  const projectService = new ProjectService();

  useEffect(() => {
    setOriginalComment(comment);
  }, [selectedRunConfigurationId])

  const handlePublishCommentChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setComment(e.target.value);
  }

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await projectService.updateRunConfiguration(projectId, selectedRunConfigurationId, {publishComment: comment});
      flyoutContext.handleCloseFlyout().then();
      updateRunConfigurationComment(comment, selectedRunConfigurationId);
      toast("Publish comment saved.", {
        containerId: "z-index-9999",
        type: "success",
      });
    } catch (e) {
      toast("Publish comment failed to save.", {
        containerId: "z-index-9999",
        type: "error",
      });
    }
    setSubmitting(false);
  }

  return (
    <>
      <p>Tag this publication so you can recognize it later...</p>

      <div className="form-horizontal">

        <div className="form-group row">
          <label className="col-sm-2 col-form-label" htmlFor="comment">Publish Tag:</label>
          <div className="col-sm-9">
            <input
              className="form-control"
              id="comment"
              data-testid="edit-run-configuration__comment"
              maxLength={50}
              value={comment}
              onChange={handlePublishCommentChange}
            />
          </div>
        </div>

        <FlyoutFooter
          submitButton={<QESButton
            qesTestId="edit-run-configuration__submit"
            disabled={submitting || comment === originalComment}
            onClick={handleSubmit}
          >Submit</QESButton>}
        />
      </div>
    </>
  )
}

export default EditRunConfiguration;